import React from 'react'
import {Grid, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import WorkableButton from "../../button/WorkableButton";

const style = theme => ({
    root: {},
    item: {
        minWidth: theme.components.popup.buttons.width,
        '&:nth-child(2)': {
            marginRight: theme.spacing(1)
        },
        '&:nth-child(3)': {
            marginLeft: theme.spacing(1)
        }
    }
})

function DoubleButton(
    {
        className,
        classes,
        labelFirst,
        labelSecond,
        onClickFirst,
        onClickSecond,
        buttonTypeFirst,
        buttonTypeSecond,
        disabledFirst,
        disabledSecond,
        workingFirst,
        workingSecond,
        justify,
        before,
        after,
    }) {
    return (
        <Grid container className={className} justifyContent={justify}>
            <Grid item>{before}</Grid>
            <Grid item className={classes.item}>
                <WorkableButton
                    fullWidth
                    variant='outlined'
                    onClick={onClickFirst}
                    type={buttonTypeFirst}
                    disabled={disabledFirst}
                    working={workingFirst}
                >
                    {labelFirst}
                </WorkableButton>
            </Grid>
            <Grid item className={classes.item}>
                <WorkableButton
                    fullWidth
                    onClick={onClickSecond}
                    type={buttonTypeSecond}
                    disabled={disabledSecond}
                    working={workingSecond}
                >
                    {labelSecond}
                </WorkableButton>
            </Grid>
            <Grid item>{after}</Grid>
        </Grid>
    )
}

DoubleButton.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.any,
    labelFirst: PropTypes.string,
    labelSecond: PropTypes.string,
    onClickFirst: PropTypes.func,
    onClickSecond: PropTypes.func,
    buttonTypeFirst: PropTypes.string,
    buttonTypeSecond: PropTypes.string,
    disabledFirst: PropTypes.bool,
    disabledSecond: PropTypes.bool,
    workingFirst: PropTypes.bool,
    workingSecond: PropTypes.bool,
}

DoubleButton.defaultProps = {}

export default withStyles(style)(DoubleButton);